export const formatAndLocaleDate = (date: moment.Moment, showTime = false) => {
    if (!date) return '- / -';
    return showTime
        ? date.locale('ru').format('HH:mm') +
              ' / ' +
              date.locale('ru').format('DD') +
              ' ' +
              date.locale('ru').format('MMM') +
              '/' +
              date.locale('ru').format('dd')
        : date.locale('ru').format('DD') +
              ' ' +
              date.locale('ru').format('MMM') +
              '/' +
              date.locale('ru').format('dd');
};
